import React from "react";

export default function TableCell({
  width,
  dataAlign: textAlign,
  dataFormat,
  content,
  row,
  style = {},
}) {
  let render = content;
  if (dataFormat) {
    render = dataFormat(content, row);
  }
  return (
    <td style={{ textAlign, width, ...style }} className="dnd-table-cell">
      {render}
    </td>
  );
}
